import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_SOLAR_ENERGY',
  GET: 'GET_SOLAR_ENERGY',
  CREATE: 'CREATE_SOLAR_ENERGY',
  EDIT: 'EDIT_SOLAR_ENERGY',
  DELETE: 'DELETE_SOLAR_ENERGY',
  DUPLICATE: 'DUPLICATE_SOLAR_ENERGY',
  CLEAR_ERROR: 'CLEAR_ERROR_SOLAR_ENERGY',
};

export const clearErrorSolarEnergy = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchSolarEnergyByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchSolarEnergy(pageSize, page, sorted, filtered, isPublic);
};

const searchSolarEnergy = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_SOLAR_ENERGY,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listSolarEnergy = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchSolarEnergy(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createSolarEnergy = (name, efficiency, area, power, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('efficiency', efficiency);
  formData.set('area', area);
  formData.set('description', description);
  if (image) formData.set('image', image, `photovoltaic_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_SOLAR_ENERGY,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editSolarEnergy = (id, name, efficiency, area, power, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (efficiency) formData.set('efficiency', efficiency);
  if (area) formData.set('area', area);
  if (typeof(description) === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `equipment_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_SOLAR_ENERGY}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteSolarEnergy = solarEnergyId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_SOLAR_ENERGY}${solarEnergyId}/`,
    })
      .then(() => ({ id: solarEnergyId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateSolarEnergy = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_SOLAR_ENERGY}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/renewable_energy/solar_energy_actions.js